import React from 'react';

export default function ManualPayPalModal({ isOpen, onClose }) {

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl p-8 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-red-600 text-xl"
          aria-label="Close modal"
        >
          &times;
        </button>

        <h2 className="text-3xl font-bold text-center mb-6">Go Premium – Manual Payment</h2>

        <div className="space-y-6 text-[15px] text-gray-700 leading-relaxed">
          <p>
            To get <strong>Poppyruz Premium</strong>, make a one-time payment of <strong>$5</strong> via PayPal below.
          </p>

          {/* PayPal Logo */}
          <div className="flex justify-center">
            <img
              src="https://www.paypalobjects.com/webstatic/icon/pp258.png"
              alt="Pay with PayPal"
              className="h-12 mb-2"
            />
          </div>

          {/* PayPal Payment Button */}
          <div className="text-center">
            <a
              href="https://www.paypal.me/poppyruz/5"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-yellow-500 text-white px-8 py-3 rounded hover:bg-yellow-600 transition inline-block text-base font-medium"
            >
              Pay with PayPal ($5)
            </a>
          </div>

          <div className="bg-gray-100 rounded p-5 border border-gray-300">
            <p className="font-semibold text-gray-900 mb-2">After Payment</p>
            <p>
              You’ll be redirected to PayPal. Once you complete the payment, you’ll receive a confirmation email from PayPal.
              Please forward your <strong>PayPal transaction ID</strong> along with your <strong>Poppyruz account email</strong> to{' '}
              <a
                href="mailto:support@poppyruz.com"
                className="text-blue-600 underline"
              >
                support@poppyruz.com
              </a>. We’ll activate your premium access manually within 8 hours.
            </p>
          </div>

          <p className="text-xs text-gray-500 italic text-center">
            We're a small indie team — thank you for supporting us 💛 Most activations are processed within a few hours.
          </p>
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={onClose}
            className="text-sm text-gray-600 hover:underline"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
